






















import {traineesClient} from "@/api/clients.context";
import {TraineeProfileModel} from "@/domain/trainees/TraineeProfileModel";

import {Component, Vue} from 'vue-property-decorator';
import EventBus from "@/components/event-bus";

@Component({})

export default class LearnLayout extends Vue {
    private id: string = '';
    private profile: TraineeProfileModel | null = null;
    private levelText: string = '';

    async mounted() {
        this.id = this.$route.params.id;
        this.profile = await traineesClient.getProfile(this.id);
        if (this.profile != null) {
            this.levelText = 'Du hast ' + this.profile.points + ' Münzen';
        }

        const self = this;
        EventBus.$on('refresh.coins', async function () {
            self.profile = await traineesClient.getProfile(self.id);
            if (self.profile != null) {
                self.levelText = 'Du hast ' + self.profile.points + ' Münzen';
            }
        });

    }

}
